var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import style from './Label.scss';
export var LabelTypes;
(function (LabelTypes) {
    LabelTypes["DEFAULT"] = "DEFAULT";
    LabelTypes["PRE"] = "PRE";
    LabelTypes["POST"] = "POST";
})(LabelTypes || (LabelTypes = {}));
var Label = React.forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, type = _a.type, rest = __rest(_a, ["className", "type"]);
    return (React.createElement("label", __assign({ ref: ref, className: classnames(style.Label, (_b = {},
            _b[style['Label--pre']] = type === LabelTypes.PRE,
            _b[style['Label--post']] = type === LabelTypes.POST,
            _b), className) }, rest)));
});
Label.TYPES = LabelTypes;
export default Label;
